import { useState, useEffect, useContext } from "react";

import "./clewStep.scss";

import ColorSchema from "../../components/kits/Color";
import ToastCustomize from "../kits/ToastCustomize";
import CustomButton from "../kits/button/CustomButton";
import useAxios from "../../services/useAxios.tsx";

import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { searchFunc } from "../../utils/helperFunction";
import SearchInputContext from "../../Search/SearchInput";

export default function ClewStep() {
  const { execute: nextStepApi } = useAxios("test/go_to_next_step");
  const { execute: campaignStepApi } = useAxios("api/lead_step_link_list");

  const { searchInput } = useContext(SearchInputContext);

  const [clewList, setClewList] = useState([]);
  const [updater, setUpdater] = useState(false);
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    campaignStepApi().then(data => {
      // setClewList(data.data);
      let temp = [...data.data];
      for (let i = 0; i < temp.length; i++) {
        temp[i] = { ...temp[i], userDescription: "" };
      }
      setClewList(temp.reverse());
      setSearchData(temp.reverse());
    });
  }, [updater]);

  useEffect(() => {
    let temp = searchFunc(
      searchInput,
      searchData.map(value => {
        return {
          ...value,
          campaign_title: value.campaign_info[0].title,
          customer_company: value.customer_info.company_name,
          customer_firstname: value.customer_info.firstname,
          customer_lastname: value.customer_info.lastname,
          step_info_title: value.step_info.title
        };
      })
    );
    setClewList(temp);
  }, [searchInput]);

  const convertTimestampToDate = timeStamp => {
    const date = new DateObject({
      date: timeStamp * 1000,
      calendar: persian
    });
    let showDate;
    timeStamp != "" ? (showDate = date.format()) : (showDate = "-");
    return showDate;
  };
  const convertTimestampToFullTime = timeStamp => {
    const date = new DateObject({
      date: timeStamp * 1000,
      calendar: persian
    });
    let showDate;
    timeStamp != ""
      ? (showDate = date.format("HH:mm") + " - " + date.format("YYYY/MM/DD"))
      : (showDate = "-");
    return showDate;
  };
  const nextStep = (data, type) => {
    let fd = new FormData();
    fd.append("campaign_id", data.campaign_id);
    fd.append("lastStep_id", data.step_info.id);
    fd.append(
      "nextStep_id",
      type == "true" ? data.true_step_info.id : data.false_step_info.id
    );
    fd.append("lead_id", data.lead_id);
    fd.append("leadStepLink_id", data.id);
    fd.append("doTm", Math.floor(new Date().getTime() / 1000));
    fd.append("resultStatus", data.status);
    fd.append("operatortext", data.userDescription);
    fd.append("doUid", data.do_uid);
    fd.append("startTm", Math.floor(new Date().getTime() / 1000));
    fd.append("customer_id", data.customer_info.id);
    nextStepApi(fd).then(data => {
      if (data.status == 1) {
        ToastCustomize({
          mainText: "درخواست شما با موفقیت ارسال شد.",
          duration: 3000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false
        });
        setUpdater(prev => !prev);
      }
    });
  };

  const finishStep = () => {
    ToastCustomize({
      mainText: "سرنخ های این کمپین به پایان رسیده است",
      duration: 4000,
      toastType: "success",
      color: "success",
      position: "top-center",
      hasHeader: false
    });
  };
  return (
    <>
      {clewList?.map((value, index) => {
        return (
          <div
            className="clewStep-style mt-5 m-3 bg-white pt-4 fw-bold"
            style={{ border: "1px solid lightgray", borderRadius: 20 }}
          >
            <div className="d-flex justify-content-between px-3 header-section">
              <div className="d-flex align-items-center campaignName">
                <div className="fs-20 ">{value.campaign_info[0].title}</div>
                <div className="fs-18 mx-1"> / </div>
                <div className="navyColor fs-18">{value.step_info.title}</div>
              </div>
              <div className="campaignDate">
                <span className="fs-11 ">تاریخ شروع کمپین : </span>
                <span className="px-2 navyColor fs-14">
                  {value.campaign_info[0].starttm != ""
                    ? convertTimestampToDate(value.campaign_info[0].starttm)
                    : "---"}
                </span>
              </div>
            </div>
            <hr style={{ borderWidth: "2px" }} />
            <div className="d-flex flex-wrap mt-4 px-5 customer">
              <div style={{ width: "40%" }}>
                <span className="fs-11">مشتری : </span>
                {value.customer_info.company_name != "" && (
                  <span className="fs-14 navyColor">
                    {value.customer_info.company_name} /{" "}
                  </span>
                )}
                <span className="fs-14 navyColor">
                  {value.customer_info.firstname} {value.customer_info.lastname}
                  / {value.customer_info.mobile}
                </span>
              </div>
              <div style={{ width: "60%" }}>
                <span className="fs-11">توضیحات وظیفه : </span>
                {value.step_info.description != "" ? (
                  <span className="navyColor fs-14">
                    {value.step_info.description}
                  </span>
                ) : (
                  <span>__</span>
                )}
              </div>
            </div>

            <div className=" d-flex  align-items-baseline  my-5 pe-3 ps-5 campaign-steps">
              <div style={{ whiteSpace: "nowrap" }} className="fs-18 mb-2">
                سابقه رهگیری کمپین :
              </div>
              <div className="d-flex flex-wrap align-items-center navyColor steps mb-2">
                {value.past_lead_step_linkd.map(v => {
                  return (
                    <div className="d-flex flex-wrap align-items-center mx-2 mb-2">
                      <div className="fs-12">
                        <span>{v.step_info.title} </span>
                        {v?.do_user_info?.fname != undefined &&
                          v?.do_user_info?.lname != undefined && (
                            <span>
                              ({" "}
                              {v.do_user_info?.fname +
                                " " +
                                v.do_user_info?.lname}{" "}
                              )
                            </span>
                          )}
                      </div>
                      {v.do_tm != "" && (
                        <div className="mx-2 fs-11">
                          [ {convertTimestampToFullTime(v.do_tm)} ]
                        </div>
                      )}
                      <div> {" -> "} </div>
                    </div>
                  );
                })}
                <div
                  className="d-flex py-3 px-2 mx-2 text-white"
                  style={{ backgroundColor: "#fecc8e", borderRadius: 10 }}
                >
                  <div className="mx-1" style={{ whiteSpace: "nowrap" }}>
                    مرحله فعلی :
                  </div>
                  <div>{value.step_info.title}</div>
                </div>
              </div>
            </div>
            {value?.true_step_info?.title != undefined &&
              value?.false_step_info?.title != undefined && (
                <hr style={{ borderWidth: "2px" }} />
              )}
            <div className="d-flex justify-content-between align-items-center w-100 mx-3 mb-2 footer-section">
              {(value?.true_step_info?.title != undefined ||
                value?.false_step_info?.title != undefined) && (
                <div
                  className="d-flex align-items-center yourdesc"
                  style={{ width: "60%" }}
                >
                  <label
                    style={{ whiteSpace: "nowrap" }}
                    className="desc-label fs-18"
                  >
                    توضیحات شما :
                  </label>
                  <div className="ms-2 w-100">
                    <textarea
                      className=" p-2"
                      style={{
                        width: "90%",
                        height: "70px",
                        // boxShadow: "2px 2px 2px 2px rgba(238,238,238,0.8)",
                        borderColor: "rgb(243, 243, 243)",
                        borderWidth: 2,
                        borderRadius: 10
                      }}
                      value={value.userDescription}
                      onChange={e => {
                        let temp = [...clewList];
                        for (let i = 0; i < temp.length; i++) {
                          if (i == index) {
                            temp[i] = {
                              ...temp[i],
                              userDescription: e.target.value
                            };
                          }
                        }

                        setClewList(temp);
                      }}
                    ></textarea>
                  </div>
                </div>
              )}
              <div
                className="d-flex justify-content-end me-3 buttons"
                style={{ width: "40%" }}
              >
                {value?.false_step_info?.title != undefined && (
                  <CustomButton
                    color="warning"
                    className="py-4 mx-2"
                    onClick={() => {
                      nextStep(value, "false");
                    }}
                  >
                    {value?.false_step_info?.title}
                  </CustomButton>
                )}
                {value.true_step_info?.title != undefined && (
                  <CustomButton
                    color="success"
                    className="py-4 mx-2"
                    onClick={() => {
                      nextStep(value, "true");
                    }}
                  >
                    {value.true_step_info?.title}
                  </CustomButton>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
